import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook,Instagram,Linkedin,Mail, MapPin, Phone } from 'lucide-react';
import logo from '../images/logo.png';

export function Footer() {
  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="mx-auto max-w-7xl px-6 py-12 lg:px-8">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <img
              src={logo}
              alt="Orthopaedic & Sports Injury Clinic"
              width={280}
              height={60}
              className="h-12 w-auto brightness-0 invert mb-4"
            />
            <p className="text-sm text-primary-foreground/80 max-w-md leading-relaxed">
              Comprehensive care for joint pain, fractures, ligament injuries and post-operative rehabilitation.
              Evidence-based medicine with personalized recovery plans.
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/about" className="hover:text-secondary transition-colors">
                  About Dr. Sujit Kumar
                </Link>
              </li>
              <li>
                <Link to="/treatments" className="hover:text-secondary transition-colors">
                  Treatments
                </Link>
              </li>
              <li>
                <Link to="/testimonials" className="hover:text-secondary transition-colors">
                  Testimonials
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="hover:text-secondary transition-colors">
                  Gallery
                </Link>
              </li>
              <li>
                <Link to="/book-appointment" className="hover:text-secondary transition-colors">
                  Book Appointment
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold mb-4">Contact</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <MapPin className="h-4 w-4 mt-0.5 flex-shrink-0" />
                <span className="text-primary-foreground/80">
                  Flat No. G8, SERENE VIEW Apartment,
                  <br />
                  PJR Enclave Main Road,
                  <br />
                  Madhavapuri Hills, Chanda Nagar,
                  <br />
                  Telangana 502032
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4 flex-shrink-0" />
                <a href="tel:+917995918882" className="hover:text-secondary transition-colors">
                  +91 9989345545
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 flex-shrink-0" />
                <a href="mailto:vrsujitkumar@gmail.com" className="hover:text-secondary transition-colors">
                  vrsujitkumar@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Facebook className="h-4 w-4 flex-shrink-0" />
                <a
                  href="https://www.facebook.com/OrthopedicSportsInjuryClinic"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-secondary transition-colors"
                >
                  Follow us on Facebook
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Instagram className="h-4 w-4 flex-shrink-0" />
                <a
                  href="https://www.instagram.com/drsujit_sportssurgeon?utm_source=qr&igsh=MXR1MGl6dmx6MGU0ZA=="
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-secondary transition-colors"
                >
                  Follow us on Instagram
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Linkedin className="h-4 w-4 flex-shrink-0" />
                <a
                  href="https://www.linkedin.com/in/vrsujit-kumar-94bb6619?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-secondary transition-colors"
                >
                  Connect on LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 border-t border-primary-foreground/20 pt-8 text-center text-sm text-primary-foreground/60">
          <p>&copy; {new Date().getFullYear()} Orthopaedic & Sports Injury Clinic. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}